import * as React from "react";
const SvgPraiz = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ...props
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#Praiz_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFD65B",
  d: "M0 9.6c0-3.36 0-5.04.654-6.324A6 6 0 0 1 3.276.654C4.56 0 6.24 0 9.6 0h4.8c3.36 0 5.04 0 6.324.654a6 6 0 0 1 2.622 2.622C24 4.56 24 6.24 24 9.6v4.8c0 3.36 0 5.04-.654 6.324a6 6 0 0 1-2.622 2.622C19.44 24 17.76 24 14.4 24H9.6c-3.36 0-5.04 0-6.324-.654a6 6 0 0 1-2.622-2.622C0 19.44 0 17.76 0 14.4z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m9.745 5.261-.747.748-.647.647-.5.5-.354.353-.217.219-.19.191c-.288.327-.34.562-.352 1 .083.481.475.804.809 1.13l.155.152.488.48.794.78c.348.345.348.345.44.622l-.225.224-1.188 1.178-.678.673-.151.15-.133.133c-.26.304-.3.558-.311.957.071.412.369.7.654.986l.23.23q.122.124.246.247l.254.254.532.532.68.681a257 257 0 0 0 1.127 1.127l.202.201c.29.255.59.276.961.268.614-.095 1.136-.77 1.554-1.192l.196-.195.634-.635.443-.442.923-.925 1.068-1.069a770 770 0 0 0 2.077-2.078l.184-.183.167-.168.145-.146c.238-.278.314-.517.32-.88l.006-.208c-.1-.574-.622-.993-1.017-1.387l-.196-.198-1.09-1.092-.937-.938-1.081-1.084a550 550 0 0 0-1.485-1.489l-.62-.62-.183-.185c-.375-.37-.755-.737-1.315-.738l-.156-.005c-.619.145-1.088.764-1.516 1.194"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "Praiz_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h24v24H0z"
}))));
export default SvgPraiz;
//# sourceMappingURL=Praiz.js.map